import { render, staticRenderFns } from "./MollieCreateProfile.vue?vue&type=template&id=4cf3a367"
import script from "./MollieCreateProfile.vue?vue&type=script&lang=ts"
export * from "./MollieCreateProfile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf3a367')) {
      api.createRecord('4cf3a367', component.options)
    } else {
      api.reload('4cf3a367', component.options)
    }
    module.hot.accept("./MollieCreateProfile.vue?vue&type=template&id=4cf3a367", function () {
      api.rerender('4cf3a367', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/MollieCreateProfile.vue"
export default component.exports